import React from 'react';

import { AlertType } from '../../../../../../common/Alert';
import { openToastAlert } from '../../../../../../common/ToastAlert/toastAlert';
import { GENERAL_ERROR_MESSAGE } from '../../../../../../constants';
import type { UploadTagSheetContentProps } from '../../types';
import UploadTagSheetStepper from '../../UploadTagSheetStepper/UploadTagSheetStepper';
import UploadTagSheetStepperProvider from '../../UploadTagSheetStepperProvider/UploadTagSheetStepperProvider';

const UploadTagSheetContent = ({ data, onClose }: UploadTagSheetContentProps): JSX.Element => {
  if (!data || !onClose) {
    openToastAlert({
      alertType: AlertType.ERROR,
      message: GENERAL_ERROR_MESSAGE,
    });

    return <></>;
  }

  return (
    <UploadTagSheetStepperProvider selectedCampaigns={data.selectedCampaigns} onCloseStepper={onClose}>
      <UploadTagSheetStepper />
    </UploadTagSheetStepperProvider>
  );
};

export default UploadTagSheetContent;
